// Roles de usuario y helpers de presentación. Fuente única para backend y front.
// Ver la matriz de permisos en apps/backend/policies/rules.js.

// Roles de equipo que una company/admin puede crear desde la gestión de usuarios.
const TEAM_ROLES = ['operator', 'gestor'];

// Roles de despacho colaborador (docs/partners-plan.md). Solo los crea un admin:
// NO están en TEAM_ROLES a propósito, una company no puede darlos de alta.
// - partner: la cuenta madre del despacho.
// - partner_operator: un abogado del despacho, con `parent_id` → el partner.
const PARTNER_ROLES = ['partner', 'partner_operator'];

// Todos los roles del sistema (== enum del modelo users).
const USER_ROLES = ['client', 'company', 'admin', 'operator', 'gestor', ...PARTNER_ROLES];

const ROLE_LABELS = {
  client: 'Cliente',
  company: 'Empresa',
  admin: 'Admin',
  operator: 'Operador',
  gestor: 'Gestor',
  partner: 'Despacho',
  partner_operator: 'Abogado',
};

/** ¿Es un rol de despacho colaborador? */
const isPartnerRole = (role) => PARTNER_ROLES.includes(role);

module.exports = {
  TEAM_ROLES,
  PARTNER_ROLES,
  USER_ROLES,
  ROLE_LABELS,
  isPartnerRole,
};
